<div>
  <div *ngIf="loading" [@fadeInOut]
       style="background: rgba(0, 0, 0, 0.3); position: absolute; z-index: 99999; width: 100%; height: 100%; text-align: center;">
    <sb-icon class="spinner" icon="loadingBlockAnimation" [animationOptions]="{autoplay: true, loop:true}"
             [style.color]="'#004F90'"></sb-icon>
  </div>
  <sb-map [roundedCorners]="true" [drawing]="false" [initialZoom]="getMapZoom()"
          [zoomControl]="true" [mapHeight]="mapHeight ? mapHeight : 740"
          [centerPoint]="getMapCenter()" [coordinateClusters]="clusters" (mapZoomEnd)="refreshBounds()"
          (mapMoveEnd)="refreshBounds()" (readyEmitter)="mapReady($event)"></sb-map>
</div>
